exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.word-cloud-wrap[data-v-270a4c4b] {\n  height: inherit;\n}\n", ""]);

// exports
